module.exports = function arrayify(value) {
  return value ? (Array.isArray(value) ? value : [value]) : []
}
